export default __webpack_public_path__ + "static/media/success.c4e4e070.png";